'use strict';

angular.module('Login')
    .factory('AuthenticationService', function ($base64, $http, $cookies, $httpParamSerializerJQLike, $location) {

        /**
         * @author Dmitry Kovalev
         * @see RequestAPIService
         * @description Сервис для взаимодействия с "Address and Warehouse management API"
         * @constructor
         */
        return {

            /**
             *
             * @param {string} username - user name
             * @param {string} password - user password
             * @param {string} company - portal company
             * @param {function} successCallback - is performed after a successful request
             * @param {function} errorCallback - is performed after the request with error
             * @param {string} requestMethod - communication method
             */
            login: function (username, password, company, successCallback, errorCallback, requestMethod) {
                var data = {
                    'client_id': authParams['client_id']
                };

                switch (requestMethod || 'auth') {
                    case 'auth':
                        data['username'] = username;
                        data['password'] = password;
                        data['grant_type'] = 'password';
                        data['client_secret'] = authParams['client_secret'];
                        break;
                    case 'refresh':
                        var refresh_token = $cookies.get('auth') ? $cookies.get('auth') : localStorage.getItem('auth');
                        refresh_token = refresh_token || false;
                        data['grant_type'] = 'refresh_token';
                        data['refresh_token'] = refresh_token;
                        break;
                }
                data['reseller_id'] = company.resellerId;
                $http({
                    url: authURL,
                    traditional: true,
                    method: 'POST',
                    data: data,
                    headers: {
                        'Authorization': 'Basic ' + $base64.encode(authParams['client_id'] + ":" + authParams['client_secret']),
                        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                    },
                    transformRequest: $httpParamSerializerJQLike
                }).then(function (response) {
                    var cookieOptions = {
                        expires: new Date((new Date()).getTime() + Math.min(40 * 60 * 1000, (response['data']['expires_in'] + 10) * 1000)),
                        path: '/',
                        secure: false
                    };
                    if ($location.protocol() == 'https') {
                        cookieOptions.secure = true;
                    }

                    const refreshToken = response['data']['refresh_token'];

                    localStorage.setItem('auth', refreshToken);
                    localStorage.setItem('c_td', angular.toJson(response));
                    $cookies.put('auth', refreshToken, cookieOptions);
                    $cookies.put('access_token', response['data']['access_token'], cookieOptions); // add token in the cookies for the webhook pass code
                    $cookies.put('resellerId', company.resellerId, cookieOptions);
                    $cookies.put('isAgreedTerm', response['data']['adminTermsAndConditionAccepted'], cookieOptions);
                    $http.defaults.headers.common.Authorization = 'Bearer ' + response['data']['access_token'];
                    successCallback(response);
                }, function (response) {
                    errorCallback(response);
                });
            },
            passwordReset: function (data, successCallback, errorCallback) {
                $http({
                    url: passwordResetURL + '?email=' + data.email + '&reseller_id=' + data.resellerId + '&client_id=' + authParams['client_id'],
                    method: 'POST',
                    transformRequest: $httpParamSerializerJQLike
                }).then(function (response) {
                    successCallback ? successCallback(response) : false;
                }, function (response) {
                    errorCallback ? errorCallback(response) : false;
                });
            },
            checkToken: function (data, successCallback, errorCallback) {

                $http({
                    url: checkTockenURL + "?token=" + data.token,
                    method: 'GET',
                    headers: {
                        'Authorization': 'Basic ' + $base64.encode(authParams['client_id'] + ":" + authParams['client_secret']),
                        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                    },
                    transformRequest: $httpParamSerializerJQLike
                }).then(function (response) {
                    successCallback ? successCallback(response) : false;
                }, function (response) {
                    errorCallback ? errorCallback(response) : false;
                });
            },

            changePassword: function (data, successCallback, errorCallback) {
                $http({
                    url: changePasswordUrl,
                    method: 'POST',
                    data: data,
                    headers: {
                        'Authorization': 'Basic ' + $base64.encode(authParams['client_id'] + ":" + authParams['client_secret']),
                        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                    },
                    transformRequest: $httpParamSerializerJQLike
                }).then(function (response) {
                    successCallback ? successCallback(response) : false;
                }, function (response) {
                    errorCallback ? errorCallback(response) : false;
                });
            },
            /**
             *
             */
            clearCredentials: function () {
                $cookies.remove('resellerId');
                $cookies.remove('auth', {
                    path: '/'
                });
                localStorage.removeItem('auth');
                $http.defaults.headers.common.Authorization = false;
            },
            /**
             *  Two Factor Authentication
             *  And
             *  Change auth method
             */
            twoFactorSendTokenToEmail: function (token, successCallback, errorCallback) {
                const url = `${ApiURL}auth/two-factor/send/email-token`;
                $http({
                    url: url,
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8',
                        'Authorization': 'Bearer' + token
                    }
                }).then(function (response) {
                    successCallback(response);
                }, function (response) {
                    errorCallback(response);
                })
            },
            changeTypeAuthMethod: function (token, type, successCallback, errorCallback) {
                const url = `${ApiURL}auth/two-factor/change/${type}`;
                $http({
                    url: url,
                    method: 'PATCH',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8',
                        'Authorization': 'Bearer' + token
                    }
                }).then(function (response) {
                    successCallback(response);
                }, function (response) {
                    errorCallback(response);
                })
            },
            twoFactorEmailVerifitacion: function (id, code, successCallback, errorCallback) {
                const url = `${ApiURL}auth/two-factor/verify/email/${code}`;
                $http({
                    url: url,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    }
                }).then(function (response) {
                    successCallback(response);
                }, function (response) {
                    errorCallback(response);
                })
            },
            twoFactorAppVerifitacion: function (id, code, successCallback, errorCallback) {
                const url = `${ApiURL}auth/two-factor/verify/${id}/${code}`;
                $http({
                    url: url,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    }
                }).then(function (response) {
                    successCallback(response);
                }, function (response) {
                    errorCallback(response);
                })
            },
            validateMFA: function (successCallback, errorCallback) {
                const url = `${ApiURL}auth/two-factor/config`;
                $http({
                    url: url,
                    method: 'GET',
                    headers: {
                        'Authorization': $http.defaults.headers.common.Authorization,
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    // transformRequest: $httpParamSerializerJQLike
                }).then(function (response) {
                    successCallback ? successCallback(response) : false;
                }, function (response) {
                    errorCallback ? errorCallback(response) : false;
                });
            }
        };
    });




//////////////////
// WEBPACK FOOTER
// ./auth/js/services/authentication.js
// module id = 152
// module chunks = 0